import Container, { Service } from 'typedi';

import {
    IAuthenticationResult,
    IAutoLoginResponseModel,
    IPendingAutoLoginModel,
    IAuthenticationService,
    IAutologinAuthenticationService,
    IExecuteWithAnalyticsResult,
} from '../models';
import { AuthenticationFlowType } from '../enums';
import { PendingAutoLoginDataBuilder } from './pending-autologindata.builder.service';
import { AuthenticationService } from './authentication.service';
import { AutoLoginAuthenticationService } from './autologin-authentication.service';

@Service()
export class PendingAuthenticationService {
    private readonly _autoLoginAuthenticationService?: IAutologinAuthenticationService;
    private readonly _authenticationService?: IAuthenticationService;
    private readonly _pendingAutoLoginDataBuilder: PendingAutoLoginDataBuilder;

    constructor() {
        this._pendingAutoLoginDataBuilder = Container.get(PendingAutoLoginDataBuilder);
        this._authenticationService = Container.get(AuthenticationService);
        this._autoLoginAuthenticationService = Container.get(AutoLoginAuthenticationService);
    }

    public autoLogin = async (
        data: any,
    ): Promise<IAuthenticationResult<IAutoLoginResponseModel>> => {
        const loginResult: IExecuteWithAnalyticsResult<IAutoLoginResponseModel> =
            await this._authenticationService.executeWithAnalytics(
                AuthenticationFlowType.Pending,
                async (): Promise<IAuthenticationResult<IAutoLoginResponseModel>> => {
                    const autoLoginData: IPendingAutoLoginModel =
                        await this._createAutoLoginData(data);
                    return this._autoLoginAuthenticationService.autoLogin(autoLoginData);
                },
            );
        await this._authenticationService.startOfferingAuthentication(loginResult);
        return loginResult?.result;
    };

    private _createAutoLoginData = async (data): Promise<IPendingAutoLoginModel> => {
        if (!data) return null;

        const autoLoginData = await this._pendingAutoLoginDataBuilder.Build(data);

        return autoLoginData;
    };
}
